/**
 * Divider Section
 * Использует переиспользуемые компоненты
 */
import { Container } from '../components';

export default function Divider({ data, styles }) {
  const style = data?.style || 'line';
  const lineWidth = data?.lineWidth || 'medium';
  const color = data?.color || 'border';

  const getWidthClass = () => {
    switch (lineWidth) {
      case 'narrow': return 'max-w-xs';
      case 'medium': return 'max-w-xl';
      case 'wide': return 'max-w-4xl';
      case 'full': return 'max-w-full';
      default: return 'max-w-xl';
    }
  };

  const getColorClass = () => {
    switch (color) {
      case 'primary': return 'border-primary';
      case 'muted': return 'border-muted';
      default: return 'border-border';
    }
  };

  return (
    <section
      style={{
        paddingTop: styles?.paddingTop ?? 32,
        paddingBottom: styles?.paddingBottom ?? 32,
        backgroundColor: styles?.backgroundColor || 'transparent'
      }}
    >
      <Container>
        {style === 'line' && (
          <hr className={`${getWidthClass()} ${getColorClass()} mx-auto border-t`} />
        )}

        {style === 'dots' && (
          <div className="flex items-center justify-center gap-2">
            <span className={`w-1.5 h-1.5 rounded-full ${color === 'primary' ? 'bg-primary' : 'bg-border'}`} />
            <span className={`w-1.5 h-1.5 rounded-full ${color === 'primary' ? 'bg-primary' : 'bg-border'}`} />
            <span className={`w-1.5 h-1.5 rounded-full ${color === 'primary' ? 'bg-primary' : 'bg-border'}`} />
          </div>
        )}

        {style === 'space' && (
          <div className="h-8" />
        )}
      </Container>
    </section>
  );
}
